import React from 'react'
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const blue = '#255A8D';

const styles = {
  root: {
    fontSize: '14px',
    background: blue,
    color: 'white',
    height: 56,
    "&:hover": {background: blue},
    //bug not working
    /*'&$disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      background: 'white'
    }*/
  }
};

class StyledButton extends React.PureComponent {
  render() {
    const { classes, children, className, ...other } = this.props;
    return (
      <Button classes={{
        root: classNames(classes.root, className),
        disabled: classNames(classes.disabled, className)
      }} {...other}>
        {children || 'class names'}
      </Button>
    );
  }

}

export default withStyles(styles)(StyledButton);



// WEBPACK FOOTER //
// ./src/js/components/inputs/StyledButton.js